module.exports = __webpack_public_path__ + "media/homepage/ayn-rand_@2x-af106706.png";